import Head from "next/head";
import Link from "next/link";
import { FaPuzzlePiece } from "react-icons/fa";
import PageShell from "@/components/layout/PageShell";
import PageHeader from "@/components/layout/PageHeader";
import { localizePuzzleCategory, puzzleCategories } from "./catalog";
import useTranslation from "next-translate/useTranslation";

export default function PuzzleHub() {
  const { t } = useTranslation("puzzles");
  const categories = puzzleCategories.map((category) =>
    localizePuzzleCategory(category, t),
  );
  return (
    <PageShell>
      <Head>
        <title>
          {t("themes.metaTitle")}
        </title>
        <meta
          name="description"
          content={t("themes.metaDescription")}
        />
      </Head>
      <PageHeader
        title={t("themes.title")}
        description={t("themes.description")}
        icon={FaPuzzlePiece}
      />
      <section className="mt-10">
        <h2 className="text-xl font-semibold text-slate-900">{t("themes.title")}</h2>
        <div className="mt-4 grid gap-3 sm:grid-cols-2 md:grid-cols-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              href={`/puzzles/${category.slug}`}
              className="rounded-lg border border-athens-gray-200 bg-white px-4 py-4 font-semibold text-altblue-700 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
              {category.short} <span aria-hidden="true">→</span>
            </Link>
          ))}
        </div>
      </section>
      <section className="mt-10 max-w-2xl text-base leading-7 text-slate-600">
        <h2 className="mb-3 text-xl font-semibold text-slate-900">
          {t("themes.habitTitle")}
        </h2>
        <p>
          {t("themes.habitText")}
        </p>
        <p className="mt-3">
          {t("themes.practiceText")}
        </p>
      </section>
      <section className="mt-10 text-sm text-slate-600">
        <h2 className="mb-3 font-semibold text-slate-900">{t("themes.morePuzzles")}</h2>
        <div className="flex flex-wrap gap-x-5 gap-y-2">
          <Link href="/puzzles" className="hover:underline">{t("nav.league")}</Link>
          <Link href="/puzzle" className="hover:underline">{t("nav.daily")}</Link>
          <Link href="/puzzles/mistakes/practice" className="hover:underline">{t("nav.mistakes")}</Link>
        </div>
      </section>
    </PageShell>
  );
}
